import { createContext, useContext, type ReactNode } from 'react';
import { services as defaultServices, type Services } from './services';

const ServicesContext = createContext<Services>(defaultServices);

export function ServicesProvider({ value, children }: { value?: Services; children: ReactNode }) {
  return <ServicesContext.Provider value={value ?? defaultServices}>{children}</ServicesContext.Provider>;
}

export function useServices(): Services {
  return useContext(ServicesContext);
}
